import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "@src/common/services/api.service";
import { ApplicationResponse } from "@src/common/domain/common.model";
import AppConstants from "@src/utils/app.constants";
import { ProjectDetailsDataStore } from "@src/views/create-project/npms/domain/npms.model";
export const ChangeCreator = createAsyncThunk<void, {projectType : any;projectId : any; userId:any;newCreatorId:any}>("project/ChangeProjectCreator",
 async ({projectType,projectId,userId,newCreatorId}) => {
    const response = await api.put<ApplicationResponse<any>>(`${AppConstants.api}/project/update-creator?projectType=${projectType}&projectId=${projectId}&userId=${userId}&newCreatorId=${newCreatorId}`)
})
export const createProject = createAsyncThunk<
  any,
  { payload: any; type: "npms" | "eci" | "custom" }
>("project/createProject", async ({ payload, type }) => {
  const url = `${AppConstants.api}/${type}/create`;
  const response = await api.post<ApplicationResponse<any>>(url, payload, {
    params: {
      RAR: 0,
    },
  });
  return response.data.data || {};
});

export const updateProject = createAsyncThunk<
  any,
  { id: string; payload: any; type: "npms" | "eci" | "custom" }
>("project/updateProject", async ({ id, payload, type }) => {
  const url = `${AppConstants.api}/${type}/update`;
  const response = await api.put<ApplicationResponse<any>>(url, payload, {
    params: {
      id: id,
      RAR: 0,
    },
  });
  return response.data.data || {};
});

export const fetchBasicDetails = createAsyncThunk<
  any,
  { projectId: string; type: "npms" | "eci" | "custom" }
>("project/fetchBasicDetails", async ({ projectId, type }) => {
  const url = `${AppConstants.api}/${type}`;
  const response = await api.get<ApplicationResponse<any>>(url, {
    params: {
      projectId: projectId,
    },
  });
  return response.data.data || {};
});

export const isUserInProject = createAsyncThunk<boolean,any>("project/isUserInProject", async ({projectType,projectId,userId}) => {
  const type = projectType.toUpperCase();
  const url = `${AppConstants.api}/project/${type}/${projectId}/has-user/${userId}`;
  const response = await api.get<ApplicationResponse<boolean>>(url);
  return response.data.data || false;
});



const BasicDetailsSlice = createSlice({
  name: "basicDetails",
  initialState: {
    minimal: {
      status: "loading",
      error: null,
      data: {},
    },
    isUserPresent:{
      status: "loading",
      error: null,
      data: false,
    },
    taskHierarchy: {
      status: "idle",
      error: null,
      data: [],
      projectId: null, 
    }
  } as ProjectDetailsDataStore & {
    taskHierarchy: {
      status: "idle" | "loading" | "failed";
      error: string | null;
      data: any[];
      projectId: string | null;
    }},
  reducers: {
    resetForm: (state) => {
      state.minimal = {
        status: "loading",
        error: null,
        data: {},
      };
      state.isUserPresent = {
        status: "loading",
        error: null,
        data: false,
      };
       state.taskHierarchy = {
        status: "idle",
        error: null,
        data: [],
        projectId: null,
      };
    },


updateBasicDetails: (state, action) => {

  const updatedData = { ...state.minimal.data, ...action.payload };

  const fieldsToRetain = ["npmsTemplateId", "eciTemplateId", "anotherOptionalField"];

  fieldsToRetain.forEach((field) => {
    if (action.payload[field] === undefined) {
      updatedData[field] = state.minimal.data[field]; 
    }
  });

  state.minimal.data = updatedData;

},
setTaskHierarchy: (state, action) => {
      const { taskList, projectId } = action.payload;
      state.taskHierarchy = {
        status: "idle",
        error: null,
        data: taskList || [],
        projectId: projectId,
      };
    },

    updateTaskHierarchy: (state, action) => {
      const { taskUpdates, projectId } = action.payload;
      
      if (state.taskHierarchy.projectId === projectId) {
        state.taskHierarchy.data = taskUpdates;
      }
    },

    addTaskToHierarchy: (state, action) => {
      const { task, projectId } = action.payload;
      
      if (state.taskHierarchy.projectId === projectId) {
        state.taskHierarchy.data.push(task);
      }
    },

    removeTaskFromHierarchy: (state, action) => {
      const { taskId, projectId } = action.payload;
      
      if (state.taskHierarchy.projectId === projectId) {
        state.taskHierarchy.data = state.taskHierarchy.data.filter(
          task => task.id !== taskId
        );
      }
    },

    clearTaskHierarchy: (state) => {
      state.taskHierarchy = {
        status: "idle",
        error: null,
        data: [],
        projectId: null,
      };
    },

  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBasicDetails.pending, (state) => {
        state.minimal = {
          status: "loading",
          data: {},
          error: null,
        };
      })
      .addCase(fetchBasicDetails.fulfilled, (state, action) => {
        state.minimal = {
          status: "idle",
          data: { ...action.payload },
          error: null,
        };
      })
      .addCase(fetchBasicDetails.rejected, (state, action) => {
        state.minimal = {
          status: "failed",
          data: {},
          error: action.error.message,
        };
      });
      builder
        .addCase(isUserInProject.pending, (state) => {
          state.isUserPresent = {
            status: "loading",
            data: false,
            error: null,
          };
        })
        .addCase(isUserInProject.fulfilled, (state, action) => {
          state.isUserPresent = {
            status: "idle",
            data: action.payload,
            error: null,
          };
        })
        .addCase(isUserInProject.rejected, (state, action) => {
          state.isUserPresent = {
            status: "failed",
            data: false,
            error: action.error.message,
          };
        });
  },
});

export const { updateBasicDetails, resetForm,setTaskHierarchy,clearTaskHierarchy } = BasicDetailsSlice.actions;
export default BasicDetailsSlice.reducer;
